import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="Footer">
      <a
        href="https://github.com/AhoySmallFry/react-weatherapp"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code
      </a>
      &nbsp;by Jordana Makin
    </footer>
  );
}
